module.exports = __webpack_public_path__ + "static/media/lu.f8137a63.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/lu.svg
// module id = 701
// module chunks = 0